import { Bookmark } from "lucide-react";
import { useUser } from "../context/UserContext";

export default function BookmarkToggle({ topicId, className = "" }) {
  const { user, toggleBookmark } = useUser();
  const active = user?.bookmarks?.includes(topicId);

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleBookmark(topicId);
      }}
      data-testid={`bookmark-toggle-${topicId}`}
      aria-pressed={active}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs transition-all active:scale-95 ${
        active
          ? "bg-brand-amber/10 border-brand-amber/50 text-brand-amber"
          : "bg-transparent border-border text-muted-foreground hover:border-brand-amber/40 hover:text-foreground"
      } ${className}`}
    >
      <Bookmark className={`h-3.5 w-3.5 ${active ? "fill-brand-amber" : ""}`} />
      {active ? "Bookmarked" : "Bookmark"}
    </button>
  );
}
